import * as firebase from 'firebase' ; 
import { isNull } from './common-utils';
import { getAjaxhelper } from './CoreAjaxHelper'; 
export const STRIPE_PUBLISHABLE_KEY: string = 'stripePublishableKey' ; 
  
export function bookingCheckoutFirebase( firebaseApp: firebase.app.App ,  responKey: string,  uuid: string, seData: any): Promise<any> { 
    return firebaseApp.firestore().collection("userData").doc(`${uuid}`).collection("bookingData").doc(`${responKey}`).set(seData);
}

/*
export function getAccountWalet(uuid: string, cur: string): Promise<any> {
    
    return 
}
*/

/**
 * membaca
 */
export function getOrRequestStripePublisableKey (): Promise<string> {
    if ( !isNull(window[STRIPE_PUBLISHABLE_KEY])) {
        return Promise.resolve(window[STRIPE_PUBLISHABLE_KEY]) ; 
    }
    return new Promise<string > ( (accept: ( n: string ) => any , reject: (exc: any ) => any  ) => {
        getAjaxhelper().get('/dynamics/app-data/stripe-data.svc')
            .then( d => {
                let stripeKey: string = d.publishableKey ; 
                accept(stripeKey); 
                window[STRIPE_PUBLISHABLE_KEY] = stripeKey;
            })
            .catch( reject) ; 
    }) ;

} 
/**
 * membaca total book days
 * @param checkoutDate tgl checkout 
 * @param endDate tgl checkin
 */
export function getTotalBookingDays( checkoutDate: Date|any , checkinDate: Date|any ): number  {
    let a: any = new Date(checkoutDate);
    let b: any = new Date(checkinDate);
    let night = Math.round((a - b) / (1000 * 60 * 60 * 24));
    return night ; 
} 
/**
 * generate path dari req available
 * @param param 
 */
export function generateReqAvailablePath( param: {
    /**
     * id dari users
     */
    uuid: string ; 
    /**
     * req key dari request
     */
    reqKey: string ; 

}): string {
    return `/userData/${param.uuid}/requestAvailable/${param.reqKey}` ; 
}


// WEBPACK FOOTER //
// ./src/utils/booking-utils.ts